/* eslint-disable */
import React, { useState } from "react";
import { Col, Row, Input, Form, Checkbox, Select, Radio } from "antd";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../Redux/actions";
import Policy from "./modals/Policy";
import DynamicFormItem from "./form/DynamicFormItem";
import ComponentTitle from "./components/ComponentTitle";
import { orderByPosition } from "utils/helperFunctions";
import IbarFullName from "./form/IbarFullName";
import { appParamater } from "utils/appDesign";

const CustomerModel = ({ data, form }) => {
  return (
    <>
      <ComponentTitle component={data} />
      <Row className="customer-model-wrapper gap">
        {orderByPosition(data.attrs).map((item, index) => {
          const { is_show = true } = item || {};
          if (item.name === "full_name" && appParamater.name === "ibar") {
            return <IbarFullName item={item} />;
          }
          if (is_show || is_show === null) {
            return (
              <Col key={index} xs={24} md={24}>
                <DynamicFormItem
                  component="customer_data"
                  data={item}
                  form={form}
                />
              </Col>
            );
          } else {
            return <></>;
          }
        })}
      </Row>
    </>
  );
};

export default CustomerModel;

// <Col xs={24} md={12}>
//                     <Form.Item
//                         name="full_name"
//                         label="Full name"
//                     >
//                         <Input />
//                     </Form.Item>
//                 </Col>
//                 <Col xs={24} md={12}>
//                     <Form.Item
//                         name="phone_number"
//                         label="Phone number"
//                     >
//                         <Input addonBefore="+994" />
//                     </Form.Item>
//                 </Col>
//                 <Col xs={24} md={12}>
//                     <Form.Item
//                         name="email"
//                         label="Email"
//                         rules={[
//                             {
//                                 type: 'email',
//                                 message: 'The input is not valid E-mail!',
//                             },
//                             {
//                                 required: true,
//                                 message: 'Enter email'
//                             }
//                         ]}
//                     >
//                         <Input />
//                     </Form.Item>
//                 </Col>
//                 <Col xs={24} md={12}>
//                     <Form.Item
//                         name="age_range"
//                         label="Age range"
//                     >
//                         <Select>
//                             <Select.Option>18-25</Select.Option>
//                             <Select.Option>25-30</Select.Option>
//                         </Select>
//                     </Form.Item>
//                 </Col>
//             </Row>
//             <Row gutter={[8, 8]} justify="center">
//                 <Col xs={{ span: 24 }} style={{ textAlign: 'center' }}>
//                     <h6>data.policy_label</h6>
//                 </Col>
//                 <Col >
//                     <Form.Item
//                         style={{ margin: 0 }}
//                         name="terms"
//                     // rules={[
//                     //     {
//                     //         required:true,
//                     //         message:'Select'
//                     //     }
//                     // ]}
//                     >
//                         <Checkbox>data.terms_title</Checkbox>
//                     </Form.Item>
//                 </Col>
//                 <Col xs={{ span: 24 }} style={{ textAlign: 'center' }}>
//                     <span>data.terms_description_text</span>
//                 </Col>
